import React, { Component } from "react";
import { userActions } from "../acciones/userActions";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import ValidacionCampo from "react-comun-seps/lib/components/ValidacionCampo";
import MensajeAlertaInline from "react-comun-seps/lib/components/MensajeAlertaInline";
import "./login.css";
import { withRouter } from "react-router-dom";
import { ApiRest } from "react-comun-seps/lib/api/ApiRest";
import { v4 as uuidv4 } from "uuid";

var I18n = require("react-redux-i18n").I18n;

class LoginPage extends Component {
  constructor(props) {
    super(props);
    // reset login status
    this.props.dispatch(userActions.logout());
    this.state = {
      username: "",
      password: "",
      submitted: false,
    };
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount() {
    this.generateSessionId();
    document.body.classList.add("login-body");
  }

  componentWillUnmount() {
    document.body.classList.remove("login-body");
  }

  onChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

  onSubmit(e) {
    e.preventDefault();
    this.setState({ submitted: true });
    const { username, password } = this.state;
    const { dispatch } = this.props;
    if (username && password) {
      dispatch(userActions.login(username, password));
    }
  }

  generateSessionId = () => {
    let id = ApiRest.obtenerDatoLocal("sessionId");
     if (!id) {
      let id = uuidv4();
      if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
        id = crypto.randomUUID();
      }
       ApiRest.guardarDatoLocal("sessionId", id);
    }
  };

  render() {
    const { username, password, submitted } = this.state;
    const { alert } = this.props;
    return (
      <div>
        <div className="text-center logo-login">
          <img src="/assets/images/login/login.png" alt="SEPS" />
        </div>
        <div className="card login-panel ui-fluid">
          <div className="login-panel-content">
            {submitted && alert && alert.detalle && (
              <MensajeAlertaInline tipoMensaje={alert.tipoMensaje} detalle={alert.detalle} />
            )}
            <div className="ui-g">
              <div className="ui-g-3 text-left">
                <img src="/assets/images/login/icon-login.svg" alt="Login" />
              </div>
              <div className="ui-g-9 text-right">
                <h2 className="welcome-text">{I18n.t("app.login")}</h2>
              </div>
              <form name="form" onSubmit={this.onSubmit}>
                <div className={"ui-g-12 text-left" + (submitted && !username ? " has-error" : "")}>
                  <label className="login-label" htmlFor="username">
                    {I18n.t("app.usuario")}
                  </label>
                  <div className="login-input">
                    <input
                      type="text"
                      className="ui-inputtext ui-widget ui-state-default ui-corner-all"
                      name="username"
                      value={username}
                      onChange={this.onChange}
                    />
                    {submitted && !username && (
                      <ValidacionCampo mensaje={I18n.t("formulario.campo_obligatorio")} />
                    )}
                  </div>
                </div>
                <div className={"ui-g-12 text-left" + (submitted && !password ? " has-error" : "")}>
                  <label className="login-label" htmlFor="password">
                    {I18n.t("app.password")}
                  </label>
                  <div className="login-input">
                    <input
                      type="password"
                      className="ui-inputtext ui-widget ui-state-default ui-corner-all"
                      name="password"
                      value={password}
                      onChange={this.onChange}
                    />
                    {submitted && !password && (
                      <ValidacionCampo mensaje={I18n.t("formulario.campo_obligatorio")} />
                    )}
                  </div>
                </div>
                <div className="ui-g-12 ui-md-6 button-pane">
                  <button
                    className="ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only"
                    aria-disabled="false"
                  >
                    <span className="ui-button-text ui-c">{I18n.t("app.ingresar")}</span>
                  </button>
                </div>
                <div className="ui-g-12 ui-md-6 link-pane">
                  <Link to="/recuperarclave">{I18n.t("app.reestrablecer_password")}</Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { alert } = state;
  return {
    alert,
  };
}

const connectedLoginPage = withRouter(connect(mapStateToProps)(LoginPage));
export { connectedLoginPage as LoginPage };
